export enum QueryKeys {
  AskTeacherQuestion = 'ask-teacher-question',
  AskTeacherCount = 'ask-teacher-count',
  WorkSchedule = 'work-schedule',
}
